import { Tag } from "../types/tag";

export type TagOption = { label: string; value: number };

export const mergeTagOptions = ({
  loadedTags,
  selected,
}: {
  loadedTags: Tag[];
  selected: TagOption[];
}): TagOption[] => {
  const loaded = loadedTags.map(tag => ({ label: tag.name, value: tag.id }));
  const merged = [...loaded, ...selected];

  const map = new Map<number, TagOption>();
  for (const option of merged) {
    if (!map.has(option.value)) {
      map.set(option.value, option);
    }
  }

  return Array.from(map.values());
};
